'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.addPathsToTree = addPathsToTree;
exports.makeFullPath = makeFullPath;
exports.findNodeAtPathInTree = findNodeAtPathInTree;
exports.findNodeWithIdInTree = findNodeWithIdInTree;
exports.findAllNodesOfTagInTree = findAllNodesOfTagInTree;
exports.getAllPropValuesInTree = getAllPropValuesInTree;
exports.searchTree = searchTree;
exports.findMappableNodes = findMappableNodes;
exports.findMappedNodes = findMappedNodes;
exports.insertNodeAtPathInTree = insertNodeAtPathInTree;
exports.repeat = repeat;
exports.replaceNodesInTree = replaceNodesInTree;
exports.replaceNodeInTree = replaceNodeInTree;
exports.removePropFromNodeInTree = removePropFromNodeInTree;
exports.setPropOnNodeInTree = setPropOnNodeInTree;
exports.deleteNodeAtPathInTree = deleteNodeAtPathInTree;
exports.undeleteNodeAtPathInTree = undeleteNodeAtPathInTree;
exports.appendChildOnNodeInTree = appendChildOnNodeInTree;
exports.unshiftChildOnNodeInTree = unshiftChildOnNodeInTree;
exports.setChildrenOnNodeInTree = setChildrenOnNodeInTree;
exports.setPropsOnNodeInTree = setPropsOnNodeInTree;
exports.setTextOnNodeInTree = setTextOnNodeInTree;
exports.mergePropOnNodeInTree = mergePropOnNodeInTree;
exports.mapDataToNode = mapDataToNode;
exports.filterTree = filterTree;
exports.forEachNodeInTree = forEachNodeInTree;
exports.mapTree = mapTree;
exports.createNode = createNode;
exports.descendantsOfNodeAtPathInTree = descendantsOfNodeAtPathInTree;
exports.transformTree = transformTree;
exports.ancestorsOfNodeAtPathInTree = ancestorsOfNodeAtPathInTree;
exports.hydrateTree = hydrateTree;

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactVisibilitySensor = require('react-visibility-sensor');

var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function addPathsToTree(tree) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var treeWithPaths = _extends({}, tree);

  _lodash2.default.forEach(treeWithPaths, function (node, key) {
    var nodePath = _lodash2.default.isEmpty(path) ? '' + key : path + '.' + key;
    var nextNode = (0, _immutabilityHelper2.default)(node, {
      $merge: {
        path: nodePath
      },
      p: {
        $merge: {
          key: nodePath
        }
      }
    });

    if (_lodash2.default.has(nextNode, 'c')) {
      nextNode.c = addPathsToTree(nextNode.c, nodePath);
    }

    treeWithPaths = (0, _immutabilityHelper2.default)(treeWithPaths, _defineProperty({}, key, {
      $set: nextNode
    }));
  });

  return treeWithPaths;
}

function makeFullPath(path) {
  return _lodash2.default.join(_lodash2.default.split(path, '.'), '.c.');
}

function findNodeAtPathInTree(tree, path) {
  var node = _lodash2.default.get(tree, makeFullPath(path));

  if (node) {
    return _extends({}, node, {
      path: path
    });
  }

  return undefined;
}

function findNodeWithIdInTree(tree, id) {
  return _lodash2.default.first(searchTree(tree, {
    p: {
      id: id
    }
  }));
}

function findAllNodesOfTagInTree(tree, tag) {
  var found = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (!_lodash2.default.isObject(tree)) {
    return found;
  }

  if (_lodash2.default.has(tree, 'c')) {
    // could be a root node
    return findAllNodesOfTagInTree(tree.c, tag, found, path);
  }

  _lodash2.default.forEach(tree, function (t, i) {
    var nextPath = _lodash2.default.isEmpty(path) ? '' + i : path + '.' + i;

    if (t.tag === tag) {
      found.push(_extends({}, t, {
        path: nextPath
      }));
    }

    findAllNodesOfTagInTree(t.c, tag, found, nextPath);
  });

  return found;
}

function getAllPropValuesInTree(tree, key) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var results = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (!_lodash2.default.isObject(tree)) {
    return results;
  }

  _lodash2.default.forEach(tree, function (t, i) {
    var nextPath = _lodash2.default.isEmpty(path) ? '' + i : path + '.' + i;

    if (_lodash2.default.has(t.p, key)) {
      results = _lodash2.default.concat(results, _lodash2.default.get(t.p, key)); // eslint-disable-line
    }

    results = _lodash2.default.concat(results, getAllPropValuesInTree(t.c, key, nextPath)); // eslint-disable-line
  });

  return _lodash2.default.uniq(results);
}

function searchTree(tree, query) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!_lodash2.default.isObject(tree)) {
    return [];
  }

  var treeWithPaths = {};

  _lodash2.default.forEach(tree, function (t, i) {
    treeWithPaths[i] = _extends({}, t, {
      path: _lodash2.default.isEmpty(path) ? '' + i : path + '.' + i
    });
  });

  var results = _lodash2.default.filter(treeWithPaths, _lodash2.default.matches(query));

  _lodash2.default.forEach(treeWithPaths, function (t, i) {
    var nextPath = _lodash2.default.isEmpty(path) ? '' + i : path + '.' + i;
    results = _lodash2.default.concat(results, searchTree(t.c, query, nextPath));
  });

  return results;
}

function findMappableNodes(tree) {
  return searchTree(tree, {
    p: {
      _mappable: true
    }
  });
}

function findMappedNodes(tree) {
  var mappableNodes = findMappableNodes(tree);
  return _lodash2.default.filter(mappableNodes, function (node) {
    return !_lodash2.default.isEmpty(node.p._mappedTo);
  });
}

function insertNodeAtPathInTree(tree, path, node) {
  var u = _lodash2.default.setWith({}, makeFullPath(path), {
    $set: node
  }, Object);

  return (0, _immutabilityHelper2.default)(tree, u);
}

function nodesAtDepth(tree, d) {
  return filterTree(tree, function (node) {
    return _lodash2.default.split(node.path, '.').length === d;
  });
}

function depth(tree) {
  var max = 0;
  mapTree(tree, function (node) {
    var d = _lodash2.default.split(node.path, '.');

    if (d.length > max) {
      max = d.length;
    }
  });
  return max;
}

function repeat(tree, data) {
  var paginator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _lodash2.default.noop;

  if (_lodash2.default.isEmpty(data)) {
    return tree;
  }

  var nextTree = _extends({}, tree);

  var maxDepth = depth(nextTree);
  var i = 1;

  var paginators = _lodash2.default.mapValues(data, function (datasource, datasourceId) {
    return paginator(datasourceId);
  });

  while (i <= maxDepth) {
    var nodes = nodesAtDepth(nextTree, i);

    var repeatedNodes = _lodash2.default.filter(nodes, function (n) {
      return _lodash2.default.has(n.p, '_mappedTo.self') && _lodash2.default.endsWith(n.p._mappedTo.self, '$[]');
    });

    var _loop = function _loop(j) {
      var node = repeatedNodes[j];
      var mappedTo = node.p._mappedTo.self;

      var datasourceId = _lodash2.default.first(_lodash2.default.split(mappedTo, '.'));

      var requirePagination = _lodash2.default.isFunction(_lodash2.default.get(paginators, datasourceId));

      var paginate = _lodash2.default.get(paginators, datasourceId);

      var dataPath = _lodash2.default.replace(mappedTo, /\.?\$\[\]/, '');

      var dataForNode = _lodash2.default.isEmpty(dataPath) ? data : _lodash2.default.get(data, dataPath);

      if (_lodash2.default.isArray(dataForNode) && !_lodash2.default.isEmpty(dataForNode)) {
        nextTree = repeatNodeInTree(nextTree, node.path, dataForNode.length);

        if (requirePagination) {
          // we only paginate on the top-most node
          // so we do this once then remove the paginator for this datasource
          var lastPath = _lodash2.default.join(_lodash2.default.initial(_lodash2.default.split(node.path, '.'))) + '.' + (dataForNode.length - 1);
          var lastNode = {
            path: lastPath,
            tag: _reactVisibilitySensor2.default,
            c: {
              0: findNodeAtPathInTree(nextTree, lastPath)
            },
            p: {
              onChange: function onChange(didBecomeVisible) {
                return didBecomeVisible && paginate();
              }
            }
          };
          nextTree = replaceNodeInTree(nextTree, lastNode);
          paginators = _lodash2.default.omit(paginators, datasourceId);
        }
      } else {
        nextTree = removeNodeFromTree(nextTree, node.path);
      }
    };

    for (var j = repeatedNodes.length - 1; j >= 0; j -= 1) {
      _loop(j);
    }

    i += 1;
  }

  return addPathsToTree(nextTree);
}

function removeNodeFromTree(tree, path) {
  var node = findNodeAtPathInTree(tree, path);

  if (node) {
    var parts = _lodash2.default.split(node.path, '.');

    var parentPath = _lodash2.default.join(_lodash2.default.initial(parts), '.');

    var key = _lodash2.default.last(parts);

    var parent = findNodeAtPathInTree(tree, parentPath);

    if (!parent) {
      // removing root
      return {};
    }

    var children = _lodash2.default.map(parent.c);

    children.splice(key, 1);
    return setChildrenOnNodeInTree(tree, parentPath, _lodash2.default.zipObject(_lodash2.default.range(0, children.length), children));
  }

  return tree;
}

function repeatNodeInTree(tree, path, times) {
  var node = findNodeAtPathInTree(tree, path);

  var nodes = _lodash2.default.map(_lodash2.default.range(0, times), function (i) {
    var nextPath = _lodash2.default.join(_lodash2.default.concat(_lodash2.default.initial(_lodash2.default.split(node.path, '.')), i), '.');

    var mergeKey = {
      $merge: {
        key: node.p.className + '-' + i
      }
    };
    var clone = (0, _immutabilityHelper2.default)(node, {
      p: mergeKey,
      path: {
        $set: nextPath
      }
    }); // remove the $[] on self which signifies array mapping

    return (0, _immutabilityHelper2.default)(clone, {
      p: {
        _mappedTo: {
          $unset: ['self']
        }
      }
    });
  });

  var parts = _lodash2.default.split(node.path, '.');

  var parentPath = _lodash2.default.join(_lodash2.default.initial(parts), '.');

  var key = _lodash2.default.last(parts); // this is which child number we are cloning


  var parent = findNodeAtPathInTree(tree, parentPath);

  var children = _lodash2.default.map(parent.c);

  children.splice.apply(children, [key, 1].concat(_toConsumableArray(nodes))); // insert the new nodes where the original node is

  var nextTree = setChildrenOnNodeInTree(tree, parentPath, _lodash2.default.zipObject(_lodash2.default.range(0, children.length), children)); // because we've cloned nodes we need to re-path

  nextTree = addPathsToTree(nextTree); // now we need to visit all descendants
  // and if any of them are mapped to something in this array
  // replace $ with the index so mapping works

  _lodash2.default.forEach(_lodash2.default.range(key, nodes.length + parseInt(key, 10)), function (i) {
    var clonePath = _lodash2.default.join(_lodash2.default.concat(_lodash2.default.initial(parts), i), '.');

    var descendants = descendantsOfNodeAtPathInTree(nextTree, clonePath); // if we mapped array foo.$[] then children may be mapped with foo.$ for an item in the array

    var matchMappedTo = _lodash2.default.replace(node.p._mappedTo.self, '$[]', '$'); // we inspect the current node and all of it's descendants for mapping of attributes to array indexes


    var mappedDescendants = _lodash2.default.concat([findNodeAtPathInTree(nextTree, clonePath)], _lodash2.default.filter(descendants, function (d) {
      return _lodash2.default.has(d.p, '_mappedTo');
    }));

    _lodash2.default.forEach(mappedDescendants, function (d) {
      nextTree = setPropOnNodeInTree(nextTree, d.path, '_mappedTo', _lodash2.default.mapValues(d.p._mappedTo, function (value) {
        if (_lodash2.default.startsWith(value, matchMappedTo)) {
          return _lodash2.default.replace(value, '$', i - key);
        }

        return value;
      }));
    }); // replace interpolated string attributes


    _lodash2.default.forEach(['action', 'href'], function (attribute) {
      var mappedAttributeDescendants = _lodash2.default.filter(descendants, function (d) {
        return _lodash2.default.isString(d.p[attribute]) && d.p[attribute].includes(matchMappedTo);
      });

      _lodash2.default.forEach(mappedAttributeDescendants, function (d) {
        nextTree = setPropOnNodeInTree(nextTree, d.path, attribute, _lodash2.default.replace(d.p[attribute], '$', i - key));
      });
    });
  });

  return nextTree;
}

function replaceNodesInTree(tree, nodes) {
  return _lodash2.default.reduce(nodes, function (nextTree, node) {
    var path = makeFullPath(node.path);

    var u = _lodash2.default.setWith({}, path, {
      $set: node
    }, Object);

    return (0, _immutabilityHelper2.default)(nextTree, u);
  }, tree);
}

function replaceNodeInTree(tree, node) {
  return replaceNodesInTree(tree, [node]);
}

function removePropFromNodeInTree(tree, path, prop) {
  var fullPath = makeFullPath(path);
  var propPath = fullPath + '.p';
  var attributePath = fullPath + '.a';

  var u = _lodash2.default.setWith({}, propPath, {
    $unset: [prop]
  }, Object);

  if (!_lodash2.default.startsWith(prop, '_')) {
    u = _lodash2.default.setWith(u, attributePath, {
      $unset: [prop]
    }, Object);
  }

  return (0, _immutabilityHelper2.default)(tree, u);
}

function setPropOnNodeInTree(tree, path, prop, value) {
  var fullPath = makeFullPath(path);
  var propPath = fullPath + '.p.' + prop;
  var attributePath = fullPath + '.p.' + prop;

  var u = _lodash2.default.setWith({}, propPath, {
    $set: value
  }, Object);

  if (!_lodash2.default.startsWith(prop, '_')) {
    u = _lodash2.default.setWith(u, attributePath, {
      $set: value
    }, Object);
  }

  return (0, _immutabilityHelper2.default)(tree, u);
}

function deleteNodeAtPathInTree(tree, path) {
  return setPropOnNodeInTree(tree, path, '_isDeleted', true);
}

function undeleteNodeAtPathInTree(tree, path) {
  return setPropOnNodeInTree(tree, path, '_isDeleted', false);
}

function appendChildOnNodeInTree(tree, path, child) {
  var node = findNodeAtPathInTree(tree, path);

  if (node) {
    var children = _lodash2.default.map(node.c);

    children = (0, _immutabilityHelper2.default)(children, {
      $push: [child]
    });
    children = _lodash2.default.zipObject(_lodash2.default.range(0, children.length), children);
    return setChildrenOnNodeInTree(tree, path, children);
  }

  return tree;
}

function unshiftChildOnNodeInTree(tree, path, child) {
  var node = findNodeAtPathInTree(tree, path);

  if (node) {
    var children = _lodash2.default.map(node.c);

    children = (0, _immutabilityHelper2.default)(children, {
      $unshift: [child]
    });
    children = _lodash2.default.zipObject(_lodash2.default.range(0, children.length), children);
    return setChildrenOnNodeInTree(tree, path, children);
  }

  return tree;
}

function setChildrenOnNodeInTree(tree, path, children) {
  var fullPath = makeFullPath(path) + '.c';

  var u = _lodash2.default.setWith({}, fullPath, {
    $set: children
  }, Object);

  return (0, _immutabilityHelper2.default)(tree, u);
}

function setPropsOnNodeInTree(tree, path, props) {
  var fullPath = makeFullPath(path);
  var propsPath = fullPath + '.p';
  var attributesPath = fullPath + '.a';

  var u = _lodash2.default.setWith({}, propsPath, {
    $merge: props
  }, Object);

  var attributes = _lodash2.default.omitBy(props, function (value, key) {
    return _lodash2.default.startsWith(key, '_');
  });

  if (!_lodash2.default.isEmpty(attributes)) {
    u = _lodash2.default.setWith(u, attributesPath, {
      $merge: attributes
    }, Object);
  }

  return (0, _immutabilityHelper2.default)(tree, u);
}

function setTextOnNodeInTree(tree, path, text) {
  var fullPath = makeFullPath(path) + '.t';

  var u = _lodash2.default.setWith({}, fullPath, {
    $set: text
  }, Object);

  return (0, _immutabilityHelper2.default)(tree, u);
}

function mergePropOnNodeInTree(tree, path, prop, value) {
  var fullPath = makeFullPath(path) + '.p.' + prop;

  var u = _lodash2.default.setWith({}, fullPath, {
    $merge: value
  }, Object);

  return (0, _immutabilityHelper2.default)(tree, u);
}

var interpolatedAttributes = {
  a: ['href'],
  form: ['action']
};

function interpolateStringWithData(string, data) {
  var interpolatedString = string;
  var interpolatablePaths = string.match(/{(.*?)}/g);

  _lodash2.default.forEach(interpolatablePaths, function (path) {
    var interpolatedPath = _lodash2.default.get(data, path.replace(/[{}]/g, ''));

    interpolatedString = interpolatedString.replace(path, interpolatedPath);
  });

  return interpolatedString;
}

function mapDataToNode(data, node) {
  var mappedNode = Object.assign({}, node);

  if (_lodash2.default.has(mappedNode.p, '_mappedTo')) {
    _lodash2.default.forEach(mappedNode.p._mappedTo, function (mappedTo, attribute) {
      if (attribute === 't') {
        // if we're mapping to text, we want to render an empty string if the data isn't present
        var t = _lodash2.default.get(data, mappedTo, '');

        var d = (0, _moment2.default)(t, _moment2.default.ISO_8601, true);
        var text = d && d.isValid() ? d.fromNow() : t;
        mappedNode = (0, _immutabilityHelper2.default)(mappedNode, {
          t: {
            $set: text
          }
        }); // for non-text attributes, we only modify the attribute if it is present in data
      } else if (_lodash2.default.has(data, mappedTo)) {
        var value = _lodash2.default.get(data, mappedTo);

        var spec = _defineProperty({}, attribute, {
          $set: attribute === 'src' && value ? String(value).replace('http:', 'https:') : value
        }); // Picture src needs a special handling


        if (attribute === 'src' && node.tag === 'picture') {
          mappedNode = (0, _immutabilityHelper2.default)(mappedNode, {
            c: {
              0: {
                p: spec
              }
            }
          });
        } else {
          mappedNode = (0, _immutabilityHelper2.default)(mappedNode, {
            p: spec
          });
        }
      }
    });
  }

  if (_lodash2.default.has(interpolatedAttributes, mappedNode.tag)) {
    _lodash2.default.forEach(interpolatedAttributes[mappedNode.tag], function (attribute) {
      var string = _lodash2.default.get(node.p, attribute, '');

      if (string.indexOf('{') >= 0) {
        var interpolatedString = interpolateStringWithData(string, data);
        mappedNode = (0, _immutabilityHelper2.default)(mappedNode, {
          p: {
            $merge: _defineProperty({}, attribute, interpolatedString)
          }
        });
      }
    });
  }

  if (!_lodash2.default.isEmpty(mappedNode.c)) {
    var children = _lodash2.default.map(mappedNode.c, function (child) {
      return mapDataToNode(data, child);
    });

    mappedNode = (0, _immutabilityHelper2.default)(mappedNode, {
      c: {
        $set: _lodash2.default.zipObject(_lodash2.default.range(0, children.length), children)
      }
    });
  }

  return mappedNode;
}

function filterTree(tree) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.identity;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  _lodash2.default.forEach(_lodash2.default.sortBy(_lodash2.default.keys(tree), function (k) {
    return parseInt(k, 10);
  }), function (key) {
    var node = tree[key];
    var nextPath = _lodash2.default.isEmpty(path) ? '' + key : path + '.' + key;

    var fullPathNode = _extends({}, node, {
      path: nextPath
    });

    if (iteratee(fullPathNode)) {
      result.push(fullPathNode);
    }

    if (_lodash2.default.has(node, 'c')) {
      filterTree(node.c, iteratee, nextPath, result);
    }
  });

  return result;
}

function forEachNodeInTree(tree) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.identity;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  _lodash2.default.forEach(tree, function (node, key) {
    var nextPath = _lodash2.default.isEmpty(path) ? key : path + '.' + key;
    iteratee(_extends({}, node, {
      path: nextPath
    }));

    if (_lodash2.default.has(node, 'c')) {
      forEachNodeInTree(node.c, iteratee, nextPath);
    }
  });
}

function mapTree(tree) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.identity;
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  _lodash2.default.forEach(tree, function (node, key) {
    var nextPath = _lodash2.default.isEmpty(path) ? key : path + '.' + key;
    result.push(iteratee(_extends({}, node, {
      path: nextPath
    })));

    if (_lodash2.default.has(node, 'c')) {
      mapTree(node.c, iteratee, nextPath, result);
    }
  });

  return result;
}

function createNode(tag, props, childrenOrText) {
  var node = {
    tag: tag,
    p: _extends({}, props)
  };

  if (_lodash2.default.isString(childrenOrText)) {
    return _extends({}, node, {
      t: childrenOrText
    });
  }

  return _extends({}, node, {
    c: childrenOrText || {}
  });
}

function descendantsOfNodeAtPathInTree(tree, path) {
  var nodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (_lodash2.default.isEmpty(path)) {
    return [];
  }

  var node = findNodeAtPathInTree(tree, path);

  if (_lodash2.default.has(node, 'c')) {
    _lodash2.default.forEach(node.c, function (c) {
      nodes.push(c);
      descendantsOfNodeAtPathInTree(tree, c.path, nodes);
    });
  }

  return nodes;
}

function transformTree(tree) {
  var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.identity;
  return _lodash2.default.reduce(tree, function (nextTree, node, key) {
    var nextNode = iteratee(node);

    if (_lodash2.default.has(nextNode, 'c')) {
      nextNode.c = transformTree(node.c, iteratee);
    }

    return (0, _immutabilityHelper2.default)(nextTree, _defineProperty({}, key, {
      $set: nextNode
    }));
  }, tree);
}

function ancestorsOfNodeAtPathInTree(tree, path) {
  if (_lodash2.default.isEmpty(path)) {
    return [];
  }

  var parts = _lodash2.default.initial(_lodash2.default.split(path, '.'));

  var nodes = [];

  while (!_lodash2.default.isEmpty(parts)) {
    nodes.unshift(findNodeAtPathInTree(tree, _lodash2.default.join(parts, '.')));
    parts.pop();
  }

  return nodes;
}

function hydrateTree(tree, config, configSubpath, parentPath) {
  return _lodash2.default.mapValues(tree, function (node, key) {
    var path = parentPath ? parentPath + '.' + key : key;
    var updateChildren = node.c && {
      c: {
        $merge: hydrateTree(node.c, config, configSubpath, path)
      }
    };
    return (0, _immutabilityHelper2.default)(node, _extends({
      path: {
        $set: path
      },
      p: {
        className: {
          $set: '' + (path === '0' ? 'mason-root ' : '') + (node.p.className ? node.p.className + ' ' : '') + 'mason-' + config.id + '-' + configSubpath + '-' + path.replace(/\./g, '-')
        },
        'data-path': {
          $set: path
        },
        id: {
          $set: 'mason-' + config.id + '-' + configSubpath + '-' + path.replace(/\./g, '-')
        },
        $unset: ['config']
      }
    }, updateChildren));
  });
}